import {
  CButton,
  CModal,
  CModalBody,
  CModalFooter,
  CModalHeader,
  CModalTitle,
} from "@coreui/react-pro";
import { useCartStore } from "../../../state/cartStore";

interface UpgradeOnItsOwnDialogProps {
  strategyName: string;
  visible: boolean;
  onKeep: () => void;
  onEmpty: () => void;
}

/** Asked when Upgrade is pressed with something already in the cart. Nothing leaves it unless she says. */
export function UpgradeOnItsOwnDialog({
  strategyName,
  visible,
  onKeep,
  onEmpty,
}: UpgradeOnItsOwnDialogProps) {
  const strategyItems = useCartStore((s) => s.strategyItems);
  const membershipItems = useCartStore((s) => s.membershipItems);
  const addOnItems = useCartStore((s) => s.addOnItems);
  const upgrade = useCartStore((s) => s.upgrade);
  const extension = useCartStore((s) => s.extension);

  const inCart =
    upgrade !== null
      ? `the upgrade of ${upgrade.name}`
      : extension !== null
        ? `the extension of ${extension.name}`
        : [...membershipItems, ...addOnItems, ...strategyItems].map((item) => item.name).join(", ");

  return (
    <CModal visible={visible} onClose={onKeep} alignment="center">
      <CModalHeader>
        <CModalTitle>Upgrade {strategyName} on its own?</CModalTitle>
      </CModalHeader>
      <CModalBody>
        <p className="mb-0">
          An upgrade is checked out by itself. Your cart has{" "}
          <strong>{inCart}</strong> in it, which you can check out after.
        </p>
      </CModalBody>
      <CModalFooter>
        <CButton color="secondary" variant="outline" onClick={onKeep}>
          Keep my cart
        </CButton>
        <CButton color="primary" onClick={onEmpty}>
          Empty cart and upgrade
        </CButton>
      </CModalFooter>
    </CModal>
  );
}
